import {} from "vue";
import { ref } from "vue";
let toastRef = ref(null);
export const setToastComponentRef = (newRef) => {
    // eslint-disable-next-line vue/no-ref-as-operand
    toastRef = newRef;
};
/**
 * Direct export to simplify usage in Options Api component.
 * Use 'useToast' for the Composition Api instead.
 */
export const Toast = {
    success(message, title = "Success", href = "") {
        toastRef.value?.showToast(message, title, "success", href);
    },
    info(message, title = "Info", href = "") {
        toastRef.value?.showToast(message, title, "info", href);
    },
    warning(message, title = "Warning", href = "") {
        toastRef.value?.showToast(message, title, "warning", href);
    },
    error(message, title = "Error", href = "") {
        toastRef.value?.showToast(message, title, "danger", href);
    },
};
export function useToast() {
    return { ...Toast };
}
